export const SET_MEETINGS = 'SET_MEETINGS'
export const SET_MEETING_IMAGES = 'SET_MEETING_IMAGES'
export const SET_MEETING_LINKS = 'SET_MEETING_LINKS'
export const RESET_STATE = 'RESET_STATE'

